import * as Sentry from '@sentry/react';
import { getSentryConfig } from 'shared/logger/config/getSentryConfig';
import { applyChannelRequestFingerprint } from 'shared/logger/config/channelRequestFingerprint';
import { shouldKeepSentryEvent } from 'shared/logger/config/sentrySampling';
import { LogData } from 'shared/types/logger';
import { version } from '../../../package.json';
import { isSentryEnabled } from 'shared/utils/environment/variables';
import { sentryLog } from 'shared/logger/sentryLog';
import { subscribeToCurrentUserIdentity } from './currentUserIdentity';

export async function initSentryInApp(): Promise<void> {
  if (isSentryEnabled()) {
    const baseConfig = getSentryConfig('React', version);

    Sentry.init({
      ...baseConfig,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.extraErrorDataIntegration(),
        Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
      ],

      beforeSend: async (event, hint) => {
        const filteredEvent = baseConfig.beforeSend
          ? await baseConfig.beforeSend(event, hint)
          : event;
        if (!filteredEvent || !shouldKeepSentryEvent(filteredEvent, hint)) {
          return null;
        }
        return applyChannelRequestFingerprint(filteredEvent, hint);
      },

      // Sampled in `beforeSend`, which keeps every service worker request failure.
      sampleRate: 1,
      tracesSampleRate: 0.1,
      ignoreErrors: ['Login required', 'Request aborted'],
    });

    subscribeToCurrentUserIdentity((identity) => Sentry.setUser(identity));
  }
}

export function appSentryLog(data: LogData): void {
  sentryLog(Sentry, data);
}
